export enum RiskFilterActions {
  setCurrentRisk = 'SET_CURRENT_RISK',
  setCurrentBlock = 'SET_CURRENT_BLOCK',
  setCurrentSimId = 'SET_CURRENT_SIM_ID',
  setKvPhase = 'SET_KV_PHASE',
  setValueType = 'SET_VALUE_TYPE',
  setRiskType = 'SET_RISK_TYPE',
  setAllianceVsClient = 'SET_ALLIANCE_VS_CLIENT'
}

export enum TaskFilterActions {
  setCompleted = 'SET_COMPLETED_TASKS',
  setIncomplete = 'SET_INCOMPLETE_TASKS'
}

export enum BucketFilterActions {
  setCompleted = 'SET_COMPLETED_BUCKETS',
  setIncomplete = 'SET_INCOMPLETE_BUCKETS'
}

export enum CommonFilterActions {
  setStart = 'SET_START',
  setDue = 'SET_DUE',
  setPhotoTimeRange = 'SET_PHOTO_TIMERANGE',
  setViewTime = 'SET_VIEW_TIME'
}
interface FilterAction {
  type: string;
  value: string[] | string;
}

export const filterReducer = <S,>(state: S, action: FilterAction): S => {
  switch (action.type) {
    case RiskFilterActions.setCurrentRisk:
      return { ...state, currentAss: action.value };
    case RiskFilterActions.setCurrentBlock:
      return { ...state, currentBlock: action.value };
    case RiskFilterActions.setCurrentSimId:
      return { ...state, currentSimId: action.value };
    case RiskFilterActions.setKvPhase:
      return { ...state, kvPhase: action.value };
    case RiskFilterActions.setValueType:
      return { ...state, valueType: action.value };
    case RiskFilterActions.setRiskType:
      return { ...state, riskType: action.value };
    case RiskFilterActions.setAllianceVsClient:
      return { ...state, allianceVsClient: action.value };

    case TaskFilterActions.setCompleted:
      return { ...state, completedTasks: action.value };
    case TaskFilterActions.setIncomplete:
      return { ...state, incompleteTasks: action.value };

    case BucketFilterActions.setCompleted:
      return { ...state, completedBuckets: action.value };
    case BucketFilterActions.setIncomplete:
      return { ...state, incompleteBuckets: action.value };

    case CommonFilterActions.setStart:
      return { ...state, start: action.value };
    case CommonFilterActions.setDue:
      return { ...state, due: action.value };
    case CommonFilterActions.setPhotoTimeRange:
      return { ...state, photoTimeRange: action.value };
    case CommonFilterActions.setViewTime:
      return { ...state, viewTime: action.value };

    default:
      return state;
  }
};
